import styled from 'styled-components'
import { COLOR, FONT_SIZE } from '../../themes'
export const InputFieldStyle = styled.div`
  cursor: ${({ cursor }) => cursor };
  pointerEvent: ${({ pointerEvent }) => pointerEvent };

  .input-field {
    border: none;
    width: 100%;
    border-radius: 4px;
    outline: none;
    ::placeholder {
      font-size: ${FONT_SIZE.TN};
      color: ${COLOR.GRAY_3};
      letter-spacing: 0.5px;
    }
  }

  .disabled,
  .disabled * {
    background-color: ${COLOR.GRAY_2} !important;
    cursor: not-allowed !important;
    color: ${COLOR.GRAY_24} !important;
  }
  }

  .icon-search-dropdown {
    width: 42px;
    height: 18px;
    vertical-align: middle;
  }

  .input-search-dropdown {
    width: calc(100% - 70px);
    margin-left: 16px;
    border: none;
    outline: none;
    line-height: 36px;
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.TN};
    ::placeholder {
      font-size: ${FONT_SIZE.TN};
      color: ${COLOR.GRAY_3};
    }
  }
  
  .div-search-select{
    border: 1px solid ${COLOR.GRAY_6};
    border-radius: 4px;
    box-shadow: none;
    color: ${COLOR.BLACK_1};
    width: auto;
  }
`
